export default __webpack_public_path__ + "static/media/bg.003d58b0.jpg";